module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgMTMgOCI+CiAgICA8cGF0aCBmaWxsPSIjOTA5MkI3IiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0wIDYuNDg2TDEuNTE3IDggNi41IDMuMDI3IDExLjQ4MyA4IDEzIDYuNDg2IDYuNSAweiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow-small.svg
// module id = 30
// module chunks = 0